export default function MascotLoadingOverlay({ message = "Veriler yükleniyor..." }) {
  return (
    <div className="absolute inset-0 flex items-center justify-center z-10 select-none pointer-events-none">
      <div className="flex flex-col items-center gap-4 sm:gap-5">
        <div className="mascot-loading-spinner" />
        <p className="text-sm sm:text-base text-gray-500 font-medium">
          {message}
        </p>
      </div>

      <style>{`
        .mascot-loading-spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #e5e7eb;
          border-top-color: #6366f1;
          border-right-color: #a78bfa;
          border-radius: 50%;
          animation: mascot-spin 0.8s linear infinite;
        }
        @media (min-width: 640px) {
          .mascot-loading-spinner {
            width: 48px;
            height: 48px;
            border-width: 5px;
          }
        }
        @keyframes mascot-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
